import { useLingui } from "@lingui/react/macro";
import type { AiDataUse } from "@rakazo/contracts";

export function ConnectionDataDisclosure({ provider, use }: { provider: string; use: AiDataUse }) {
  const { t } = useLingui();
  return (
    <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
      {use === "live"
        ? t`Saving this key allows ${provider} to process live audio and recent chat context in this workspace.`
        : use === "voice"
          ? t`Saving this key allows ${provider} to process recordings and text for speech in this workspace.`
          : use === "memory"
            ? t`Saving allows ${provider} to process conversation summaries and memories in this workspace.`
            : t`Saving allows ${provider} to process messages and bot context in this workspace.`}
    </p>
  );
}
